import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from '@mui/material';
import LocaleLink from '@components/LocaleLink';
import { withRouter } from 'next/router';
import { flowRight as compose } from 'lodash';

function TertiaryDropDownRoute(props) {
  const { label, route, router, routeName, onClick } = props;
  const { query } = router;
  const { defaultMessage } = label;
  const isSelected = routeName === route;
  return (
    <div style={{ alignContent: 'center' }}>
      <LocaleLink route={route} params={{ ...query }} passHref>
        <MenuItem onClick={onClick} selected={isSelected}>
          {defaultMessage?.[0]?.value}
        </MenuItem>
      </LocaleLink>
    </div>
  );
}

TertiaryDropDownRoute.propTypes = {
  label: PropTypes.shape({ defaultMessage: PropTypes.string }).isRequired,
  route: PropTypes.string.isRequired,
  router: PropTypes.shape({ query: PropTypes.shape({}) }).isRequired,
  routeName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

const ComposedTertiaryDropDownRoute = compose(withRouter)(TertiaryDropDownRoute);
export default ComposedTertiaryDropDownRoute;
